/**
 * Custom hook untuk mengambil detail booking berdasarkan ID.
 * 
 * API Endpoint: GET `/api/bookings/:id`
 * API Version: 3.0
 * 
 * @param {string} id - ID Rate Plan
 * @param {string} include - Include data (e.g: roomType,children)
 * @returns {object} - Return value berupa object dengan key `data`, `isLoading`, dan `error`.
 * @example
 * const { data, isLoading, error } = useShowRatePlan('1', 'roomType,children');
 */


import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ShowRatePlanSchema } from "../response/ShowRatePlanResponse";

interface ShowRatePlanProps {
    id?: string;
    include?: string;
}

const useShowRatePlan = ({ id, include }: ShowRatePlanProps) => {
    const params = {
        ...(include && { include }),
    };

    return useQuery({
        queryKey: ['rooms', 'rates', 'index', id, include],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/rate-plan/${id}`, { params });

                // Validasi response
                const validationResult = ShowRatePlanSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Rateplan data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Rateplan`, error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useShowRatePlan;